<script setup>
import { VDateInput } from 'vuetify/labs/VDateInput'
const props = defineProps({
    initialValue: {
        type: String,
        default: null
    }
})

const modelValue = ref([])

const emits = defineEmits(['updateFilter'])

const datetoUnixTime = (date) => {
    try {
        return new Date(date).getTime() / 1000
    } catch (e) {
        return null
    }
}

const unixTimeToDate = (date) => {
    try {
        return new Date(date * 1000)
    } catch (e) {
        return null
    }
}

const updateFilter = () => {
    const from = datetoUnixTime(dateFrom.value)
    const to = datetoUnixTime(dateTo.value)

    const payloadString = `${from ? from : ''}/${to ? to : ''}`
    emits('updateFilter', payloadString)
}

const dateFrom = ref(null)
const dateTo = ref(null)

onMounted(() => {
    if (props.initialValue) {
        const values = props.initialValue.split('/')

        dateFrom.value = unixTimeToDate(values[0])
        dateTo.value = unixTimeToDate(values[1])
    }
})
</script>
<template>
    <div class="single-filter-ui">
        <v-date-input
            v-model="dateFrom"
            :label="$t('dateFrom')"
            prepend-icon=""
            prepend-inner-icon="$calendar"
            class="date-from"
            @update:model-value="updateFilter($event)"
        ></v-date-input>
        <v-date-input
            v-model="dateTo"
            :label="$t('dateTo')"
            prepend-icon=""
            prepend-inner-icon="$calendar"
            class="date-to"
            @update:model-value="updateFilter($event)"
        ></v-date-input>
    </div>
</template>
